import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { getAmountRangeToString } from '../../helpers/humanization.js';
import { toTerm } from '../../helpers/toTerm.js';

const getCreditsTerms = item => {
    const conditions = [];
    const { sumFrom, sumTo, termFrom, termTo, currency, unitFrom, unitTo } = item;
    const amount = {
        from: sumFrom,
        to: sumTo,
    };
    const amountValue = getAmountRangeToString({ amountRange: amount, currency });
    let termValue = '';
    if (termTo && termFrom) {
        if (unitFrom === unitTo) {
            termValue = `от ${termFrom} до ${termTo} ${pluralizeByUnit(termTo, toTerm(unitTo), { possessive: true })}`;
        }
        else {
            termValue = `от ${termFrom} ${pluralizeByUnit(termFrom, toTerm(unitFrom), {
                possessive: true,
            })} до ${termTo} ${pluralizeByUnit(termTo, toTerm(unitTo), {
                possessive: true,
            })}`;
        }
    }
    else if (termFrom) {
        termValue = `от ${termFrom} ${pluralizeByUnit(termFrom, toTerm(unitFrom), { possessive: true })}`;
    }
    else if (termTo) {
        termValue = `до ${termTo} ${pluralizeByUnit(termTo, toTerm(unitTo), { possessive: true })}`;
    }
    amountValue &&
        conditions.push({
            value: amountValue,
            description: `Сумма`,
            wide: true,
            key: 'amount',
            labelKey: 'term',
        });
    termValue &&
        conditions.push({
            value: termValue,
            description: `Срок`,
            wide: true,
            key: 'term',
            SOValue: `на срок ${termValue}`,
        });
    return conditions;
};

export { getCreditsTerms };
//# sourceMappingURL=credits.js.map
